'use strict';

var $ = require('jquery');

function wrapRevealModals() {
	$('a[data-delegate-reveal-id]').on('click', function (e) {
		if (e.target.parentElement.hasAttribute('maintain-scroll-position') === true || e.target.hasAttribute('maintain-scroll-position') === true) {
			e.preventDefault();
			e.stopPropagation();

			const scrollPosY = window.scrollY;
			const scrollPosX = window.scrollX;

			$('#' + $(this).data('delegate-reveal-id')).foundation('reveal', 'open');

			window.setTimeout(() => {
				window.scroll(scrollPosX, scrollPosY);
			}, 0);
		}
		else {
			$('#' + $(this).data('delegate-reveal-id')).foundation('reveal', 'open');
		}
	});
}

module.exports = {
	init: wrapRevealModals
};
